import React from 'react';

const ErrorPage = () => {
	return <div>Error Page</div>;
};

export default ErrorPage;
